"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Spinner = function Spinner() {
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "spinner"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: t('loading'),
    appearance: "primary",
    size: 2
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    marginTop: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 1,
    text: t('cancelingAddon')
  })));
};
var _default = Spinner;
exports.default = _default;